import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * ຄືນຫນ້າກ່ອນໜ້າ — ໃຊ້ router.history.back() ແທນການ navigate ໄປ path ຄົງທີ່
 */
export function useRouterBack(): () => void {
  const router = useRouter();
  return useCallback(() => {
    router.history.back();
  }, [router]);
}
